import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import {Utilities} from '@learningblocks/exp-constants';

const {SLIDE_NODE, checkIfNodeComplete} = Utilities;
const NODE_STATES = {
  EMPTY: 'EMPTY',
  CURRENT: 'CURRENT',
  COMPLETE: 'COMPLETE',
};

/**
 * OverlapGroup: DesignSlideTwo Component; It acts as a Joining Node between
 * Two BoxGroup Components. Takes an array of groupNodes and display only a
 * Single current GroupNode to the UI at a time. When all groupNodes are
 * completed, display the last groupNode.
 */
export function OverlapGroup(props) {
  const setNodeState = (node) => {
    let nodeComplete = checkIfNodeComplete(node);
    let nodeState = NODE_STATES.EMPTY;
    if (node.current) nodeState = NODE_STATES.CURRENT;
    if (nodeComplete) nodeState = NODE_STATES.COMPLETE;
    return nodeState;
  };

  const renderByType = (node) => {
    switch (node.nodeType) {
      case SLIDE_NODE.JOINT_PATH_SELECT:
        return React.cloneElement(props.hexPathSelectRow, {
          ...node,
          key: node.nodeId,
        });
      case SLIDE_NODE.JOINT_DRAG_DROP:
        return React.cloneElement(props.jointDragDropRow, {
          ...node,
          key: node.nodeId,
          nodeState: setNodeState(node),
          nodeHolder: React.cloneElement(
            props.jointDragDropRow.props.nodeHolder,
            {
              current: node.current,
            }
          ),
        });
      default:
        return null;
    }
  };

  const renderLastNode = () => {
    let lastIndex = props.groupNodes.length - 1;
    return renderByType(props.groupNodes[lastIndex]);
  };

  const renderGroupNode = () => {
    if (props.groupComplete) {
      return renderLastNode();
    } else {
      for (let node of props.groupNodes) {
        if (node.current) {
          return renderByType(node);
        }
      }
      return null;
    }
  };

  return <div className='overlapGroup'>{renderGroupNode()}</div>;
}

OverlapGroup.propTypes = {
  /**
   * Unique Id for the Group
   */
  groupId: PropTypes.number,
  /**
   * List of nodes displayed in group
   */
  groupNodes: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Boolean specifying if node is currently in focus
       */
      current: PropTypes.bool,
      /**
       * UniqueId for the node,
       */
      nodeId: PropTypes.number,
      /**
       * Type of groupNode
       */
      nodeType: PropTypes.oneOf([
        SLIDE_NODE.JOINT_DRAG_DROP,
        SLIDE_NODE.JOINT_PATH_SELECT,
      ]),
      /**
       * List of Typed Unit components associated with Node
       */
      nodeComponents: PropTypes.arrayOf(PropTypes.object),
    })
  ),
  /**
   * Boolean specifying if group is complete
   */
  groupComplete: PropTypes.bool,
  /**
   * DragDrop Row Component for HexagonCard Nodes.
   */
  jointDragDropRow: PropTypes.element.isRequired,
  /**
   * Path Select Component for HexagonCard Nodes.
   */
  hexPathSelectRow: PropTypes.element.isRequired,
};

OverlapGroup.defaultProps = {
  groupComplete: false,
  groupNodes: [],
};
